import { BlockComponentFactory } from '../BlockFactory'
import Divider from 'antd/lib/divider'
import { DividerBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'

const DIVIDER_LABEL_FONT_STYLE: React.CSSProperties = {
    ...LABEL_FONT_STYLE,
    fontSize: '12px',
}

export const DividerBlockComponent = BlockComponentFactory.createBlockComponent<DividerBlockProps>(
    props => {
        const {
            label,
            dashed = false,
            titlePlacement = 'center',
            visibility = 'visible',
            style,
        } = props

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'block',
        }

        return (
            <div style={containerStyle}>
                <Divider
                    dashed={dashed}
                    orientation={titlePlacement}
                    style={{ borderColor: '#D8D8D8', margin: 0 }}
                >
                    {label && <LabelBlock label={label} labelStyle={DIVIDER_LABEL_FONT_STYLE} />}
                </Divider>
            </div>
        )
    }
)
